import instance from "../utils/network";

export function checkAlreadyRewarded(clubId: number, userId: number) {
  const data = {
    clubId,
    userId,
  };
  return instance.post(`/nest/club-reward/check-already-rewarded`, data);
}
